module.exports = __webpack_public_path__ + "img/my_artist.d5cf502d.svg";